<template>
  <div>
    <h1 class="page-title">{{ $t("NewOffer.title") }}</h1>
    <div class="card card-transparent">
      <div class="card-block">
        <div class="row">
          <div class="col-md-10 offset-md-1">
            <offer-form v-if="dataReady" :offerId="null"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OfferForm from './OfferForm'

export default {
  name: 'NewOffer',
  data: function(){
    return {
      dataReady: false
    }
  },
  components: { OfferForm },
  computed: {
    originalOfferId(){
      return this.$route.params.original_offer_id;
    }
  },
  mounted: async function(){
    if(this.originalOfferId){
      await this.$store.dispatch('offers/clone', this.originalOfferId);
    } else {
      this.$store.dispatch('offers/reset');
    }
    this.dataReady = true;
  }
}
</script>



// WEBPACK FOOTER //
// src/components/offers/NewOffer.vue